// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'submit_package_size' | 'upload_package_select' | 'see_compensation_information'

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type UserInputEventArgs = {
  screen?: string
  target: string
  value?: string | null
  state: 'focus' | 'unfocus'
  tempUuid?: string
  isDynamic?: boolean
}

export const userInputEvent = (args: UserInputEventArgs) => {
  const { state, target, value, screen, tempUuid, isDynamic } = args
  const extra = {
    screen,
    target,
    value,
    state,
    upload_session_id: tempUuid,
    is_dynamic: isDynamic || false,
  }

  return {
    event: 'user.input',
    extra,
  }
}

type ItemUploadClickEventArgs = {
  screen?: string
  target: UserTarget
  targetDetails?: string | null
  uploadSessionId: string | null
}

type ItemUploadClickEventExtra = {
  screen?: string
  target: UserTarget
  target_details?: string | null
  upload_session_id: string | null
}

export const itemUploadClickEvent = (args: ItemUploadClickEventArgs) => {
  const { screen, target, targetDetails, uploadSessionId } = args

  const extra: ItemUploadClickEventExtra = {
    target,
    upload_session_id: uploadSessionId,
  }

  if (screen) extra.screen = screen
  if (targetDetails) extra.target_details = targetDetails

  return {
    event: 'upload_form.user.click',
    extra,
  }
}

type ItemUploadViewScreenEventArgs = {
  screen: string
  details?: string
  uploadSessionId: string | null
}

type ItemUploadViewScreenEventExtra = {
  screen: string
  details?: string
  upload_session_id: string | null
}

export const itemUploadViewScreenEvent = (args: ItemUploadViewScreenEventArgs) => {
  const { screen, details, uploadSessionId } = args

  const extra: ItemUploadViewScreenEventExtra = {
    screen,
    upload_session_id: uploadSessionId,
  }

  if (details) extra.details = details

  return {
    event: 'upload_form.user.view_screen',
    extra,
  }
}
